export const CauseInputFieldLabels = {
  title: 'Title',
  description: 'Description',
  initialHarm: 'Initial Probability',
  initialRisk: 'Initial Risk',
  residualHarm: 'Residual Probability',
  residualRisk: 'Residual Risk',
  attachment: 'Attachments',
  assignTask: 'Assign Task',
  assignControls: 'Assign Controls',
  taskFiles: 'Document References'
} as const;

export type HazardCauseInputField = keyof typeof CauseInputFieldLabels;

export const CauseInputFields: HazardCauseInputField[] = Object.keys(
  CauseInputFieldLabels
) as HazardCauseInputField[];
